import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { createTheme, MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { ModalsProvider } from '@mantine/modals';
import { Toaster } from 'react-hot-toast';

// Design tokens + layout css — import order matters: tokens first so
// every subsequent sheet can reference the CSS variables.
import './design/tokens.css';
import './design/shell.css';
import './design/dashboard.css';
import './design/screens.css';
import './design/screens-ext.css';
import './design/sub-pages.css';
import './design/workshop.css';
import './design/fleet.css';

// Tailwind base + legacy Roboto import — keep while un-migrated pages still
// use Tailwind utilities. This layer comes AFTER design tokens so our own
// typography/body styles aren't clobbered by preflight.
import './index.css';

import App from './App.js';
import UpdateBanner from './shell/UpdateBanner.js';
import { GlobalProvider } from './context/GlobalContext.js';
import { AppStateProvider } from './shell/AppStateContext';
import modals from './lib/modals.js';

const theme = createTheme({});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MantineProvider theme={theme}>
      <ModalsProvider modals={modals}>
        <GlobalProvider>
          <AppStateProvider>
            <Router>
              <App />
              <UpdateBanner />
              <Toaster position="top-right" toastOptions={{ style: { fontFamily: 'var(--font-ui)' } }} />
            </Router>
          </AppStateProvider>
        </GlobalProvider>
      </ModalsProvider>
    </MantineProvider>
  </React.StrictMode>
);
